import { render, staticRenderFns } from "./PaymentSingleReceived.vue?vue&type=template&id=47cedc7b"
import script from "./PaymentSingleReceived.vue?vue&type=script&lang=js"
export * from "./PaymentSingleReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports